<h2 class="default-dialog-header font-weight-normal" mat-dialog-title>
	<span fxFlex>Start typing to give feedback</span>
	<span fxFlex="15" fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog(null)" class="primary-light-color cursor-pointer"
			>close</mat-icon
		>
	</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content">
	<mat-form-field appearance="fill" class="m-t-1" fxFlex>
		<mat-label>Feedback</mat-label>
		<textarea
			(keyup.enter)="$event.stopImmediatePropagation();closeDialog(feedback)"
			[(ngModel)]="feedback"
			matAutosizeMinRows="5"
			matInput
			matTextareaAutosize
			maxlength="255"
		></textarea>
		<mat-hint align="end">{{IS_NOT_EMPTY(feedback) ? feedback.length : 0}}/255</mat-hint>
	</mat-form-field>
</mat-dialog-content>
<mat-divider></mat-divider>

<mat-dialog-actions class="default-dialog-action">
	<div fxFlex="100" fxLayoutAlign="end end" fxLayoutGap="1rem">
		<button (click)="closeDialog(feedback)" color="primary" mat-raised-button>Submit</button>
	</div>
</mat-dialog-actions>
